const isPlainObject = (value) =>
  Object.prototype.toString.call(value) === "[object Object]";

export const normalizeSearchResults = (items) => {
  const safeItemsArray = Array.isArray(items) ? items : [];

  return safeItemsArray.map((item) => {
    const safeItem = isPlainObject(item) ? item : {};

    return {
      ...safeItem,
      skills: Array.isArray(safeItem.skills) ? safeItem.skills : [],
    };
  });
};